// Item.vue

<template>
    <div>
        <div class="text-muted float-right">{{ $parent.productdata.currency }}{{ totalPrice.toLocaleString() }}</div>
        <div>
            <h6 class="my-0" v-if="(item.style > -1)">{{ item.productList[item.style].name }}</h6>
        </div>
        <br />
        <div class="float-right">
            <button type="button" class="btn btn-sm btn-light" @click="edit()"><i class="fa fa-pencil-square" aria-hidden="true"></i></button>
            <button type="button" class="btn btn-sm btn-light" v-b-tooltip.hover title="Create Duplicate Item" v-on:click="addDuplicate()"><i class="fa fa-plus" aria-hidden="true"></i></button>
            <button type="button" class="btn btn-sm btn-light" @click="deleteme()"><i class="fa fa-trash" aria-hidden="true"></i></button>
        </div>
        <div>
            <small class="text-muted">
                <span v-if="item.customerName">{{ item.customerName}} - {{ item.spaReason}} <br /></span>

                <span v-if="item.spaBrand">
                    <span v-if="item.spaBrand === 'other'">{{ item.spaYear }} {{ item.spaBrandOther }} {{ item.spaModel }} </span>
                    <span v-else>{{ item.spaYear }} {{ item.spaBrand }} {{ item.spaModel }} </span>
                    <br />
                </span>
                <span v-if="item.completionOption">
                  Completion date: {{ item.completionOption.toUpperCase() }} {{ item.completionDate }}
                  <br>
                </span>
                <span v-if="item.measurementA">
                    A: {{ item.measurementA }}in. 
                    B: {{ item.measurementB }}in. 
                    H: {{ item.hingeLength }}in. 
                    CR: {{ item.cornerRadius}}in.
                    AH: {{ item.acrylicHeight}}in.
                    <br />
                </span>
                <span v-if="(item.style > -1) && (item.decoShield > -1)">
                    Deco: {{ item.productList[item.style].decos[item.decoShield].name }}
                </span>
                <span v-if="(item.style > -1) && (item.decoShield > -1) && (item.decoTrim > -1)">
                    Trim: {{ item.productList[item.style].decos[item.decoShield].trims[item.decoTrim].name }}
                </span>
                <div v-if="(item.style > -1)">
                    <div v-for="(value,key) in item.options" :key="key">
                      <div v-if="value !== undefined">
                          {{ item.productList[item.style].options[key].name }}:
                          {{ item.productList[item.style].options[key].values[value].name }}
                      </div>
                    </div>
                </div>

                <div v-if="!isComplete">
                    <b>INCOMPLETE</b>
                </div>

                <span v-if="item.comments">
                    Comments: {{ item.comments }}
                </span>
            </small>
        </div>
        <b-modal ref="smartop-modal-1" id="smartop-modal-1" title="Configure Smartop - Cover Information" no-stacking no-close-on-backdrop>
            <label for="spaBrand">Spa Brand *</label>
            <b-form-select v-model="item.spaBrand" class="mb-3">
                <option></option>
                <option v-for="(value) in productdata.brands" :key="value">{{ value }}</option>
                <option v-if="item.source === 'default'" value="other">Other...</option>
            </b-form-select>

            <div v-if="item.spaBrand === 'other'" class="mb-3">
                <label for="spaBrandOther">Other Brand *</label>
                <b-form-input name="spaBrandOther" v-model="item.spaBrandOther"></b-form-input>
            </div>


          <template >
            <div class="row">
              <div class="col-md-6 mb-3">
                <b-form-group id="example-input-group-1" label="Spa Model *" label-for="spaModel">
                  <b-form-select
                      v-if="item.source === 'bullfrog'"
                      id="spaModel"
                      name="spaModel"
                      v-model="item.spaModel"
                      class="mb-3"
                  >
                    <option value="S150">S150</option>
                    <option value="S200">S200</option>
                  </b-form-select>
                  <b-form-input
                      v-else
                      id="spaModel"
                      name="spaModel"
                      v-model="item.spaModel"
                      aria-describedby="input-1-live-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback">
                    This is a required field.
                  </b-form-invalid-feedback>

                </b-form-group>
              </div>
              <div class="col-md-6 mb-3">
                <label for="spaYear">Spa Year *</label>
                <b-form-input maxlength="4" v-on:keypress="isNumber($event)" name="spaYear" v-model="item.spaYear"></b-form-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="customerName">Customer Name *</label>
                <b-form-input name="customerName" v-model="item.customerName"></b-form-input>
              </div>
              <div class="col-md-6 mb-3">
                <label for="spaReason">Reason *</label>
                <b-form-select v-model="item.spaReason" class="mb-3">
                  <option></option>
                  <option v-for="value in productdata.reasons" :key="value">{{ value }}</option>
                </b-form-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="salespersonFirstName">Salesperson First Name *</label>
                <b-form-input name="salespersonFirstName" v-model="item.salespersonFirstName"></b-form-input>
              </div>
              <div class="col-md-6 mb-3">
                <label for="salespersonLastName">Salesperson Last Name *</label>
                <b-form-input name="salespersonLastName" v-model="item.salespersonLastName"></b-form-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="location">Store Location *</label>
                <b-form-input name="location" v-model="item.location"></b-form-input>
              </div>
              <div class="col-md-6 mb-3">
                <label for="departmentFrom">Which Department Sold This Smartop *</label>
                <b-form-select name="salespersonLastName" v-model="item.departmentFrom">
                  <option></option>
                  <option value="operations">Operations Department</option>
                  <option value="sales">Sales Department</option>
                </b-form-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mb-3">
                <label for="completionOption">Desired Completion Date:</label>
                <b-form-select v-model="item.completionOption" class="mb-3">
                  <option></option>
                  <option value="standard">Standard Lead Time</option>
                  <option value="rush">Rush ($200 standard cover/$400 swim spa cover)</option>
                  <option value="date">Custom Date</option>
                </b-form-select>
              </div>
              <div class="col-md-12 mb-3" v-if="item.completionOption === 'date'">
                <label for="completionDate">Choose a date</label>
                <b-form-datepicker
                    v-model="item.completionDate"
                    id="datepicker-dateformat2"
                    locale="en"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
                    no-flip
                ></b-form-datepicker>
              </div>
            </div>
          </template>

            <div slot="modal-footer">
                <b-button @click="validateStepOne()">Next&nbsp;&nbsp;<i class="fas fa-chevron-right"></i></b-button>
            </div>

        </b-modal>

        <b-modal ref="smartop-modal-2" id="smartop-modal-2" title="Configure Smartop - Measurements" no-stacking no-close-on-backdrop>
            <div class="row">
                <div v-if="item.source === 'default'" class="col-md-9 mb-3">
                    <a href="/pdf/Smartop%20Measurement%20Form.pdf" target="_new">Click here for detailed measuring instructions</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-3">
                    <label for="measurementA">Measurement A *</label>
                    <b-form-select v-if="item.source === 'bullfrog'" v-model="item.measurementA" class="mb-3">
                        <option v-for="(value,key) in getCustomCorners(item.spaModel).measurementA" :key ="key" :value="value">{{ value }} in.</option>
                    </b-form-select>
                  <b-form-select v-if="item.source === 'default'" @change="updateHingeLengths()" v-model="item.measurementA" class="mb-3">
                    <option></option>
                    <option v-for="(value,key) in productdata.measurements.a" :key ="key" :value="value">{{ value }} in.</option>
                  </b-form-select>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="measurementB">Measurement B *</label>
                    <b-form-select @change="updateHingeLengths()" v-model="item.measurementB" class="mb-3">
                        <option v-if="item.source === 'default'"></option>
                        <option v-for="(value,key) in productdata.measurements.b" :key ="key" :value="value">{{ value }} in.</option>
                    </b-form-select>
                </div>
                <div class="col-md-4 mb-3">
                    <label for="hingeLength">Hinge Length *</label>
                    <b-form-select v-model="item.hingeLength" class="mb-3">
                        <option v-if="item.source === 'default'"></option>
                        <option v-for="(value,key) in productdata.measurements.hingeLength" :key="key" :value="value">{{ value }} in.</option>
                    </b-form-select>
                    <b-form-text v-if="item.source === 'default'" id="radius-help-block">
                        Hinge length cannot exceed 110 in.
                    </b-form-text>

                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="cornerRadius">Corner Radius *</label>
                    <b-form-select v-if="item.source === 'bullfrog'"  v-model="item.cornerRadius" class="mb-3" aria-describedby="radius-help-block">
                        <option v-for="(value,key) in getCustomCorners(item.spaModel).cornerRadius" :key ="key" :value="value">{{ value }} in.</option>
                        <!-- <option key="-1" value="Custom ">Custom - Enter Details In Comments</option> -->
                    </b-form-select>
                  <b-form-select v-if="item.source === 'default'"  v-model="item.cornerRadius" class="mb-3" aria-describedby="radius-help-block">
                    <option></option>
                    <option v-for="(value,key) in productdata.measurements.cornerRadius" :key ="key" :value="value">{{ value }} in.</option>
                    <!-- <option key="-1" value="Custom ">Custom - Enter Details In Comments</option> -->
                  </b-form-select>
                    <b-form-text v-if="item.source === 'default'" id="radius-help-block">
                        <a href="/pdf/Smartop%20Measurement%20Form.pdf" target="_new">How do I select the correct corner radius?</a>
                    </b-form-text>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="acrylicHeight">Acrylic Height *</label>
                    <b-form-select v-model="item.acrylicHeight" class="mb-3">
                        <option v-if="item.source === 'default'"></option>
                        <option v-for="(value,key) in productdata.measurements.acrylicHeight" :key ="key" :value="value">{{ value }} in.</option>
                    </b-form-select>
                </div>

            </div>
            <div slot="modal-footer">
                <b-button v-b-modal.smartop-modal-1><i class="fas fa-chevron-left"></i>&nbsp;&nbsp;Previous</b-button>&nbsp;
                <b-button @click="validateStepTwo()">Next&nbsp;&nbsp;<i class="fas fa-chevron-right"></i></b-button>
            </div>
        </b-modal>


        <b-modal ref="smartop-modal-3" id="smartop-modal-3" title="Configure Smartop - Style" no-stacking no-close-on-backdrop>
            <label for="style">Smartop Style *</label>
          <b-form-select v-model="item.style" class="mb-3" @change="updateDecos">
            <option v-if="item.source === 'default'"></option>
            <option v-for="(value, key) in item.productList" :key="key" :value="key" :disabled="(   ((parseFloat(value.allowable_size.min) > parseFloat(item.measurementA)) && (parseFloat(value.allowable_size.min) > parseFloat(item.measurementB))) || ((parseFloat(value.allowable_size.max) < parseFloat(item.measurementA)) || (parseFloat(value.allowable_size.max) < parseFloat(item.measurementB))) )">{{ value.name }}</option>
          </b-form-select>

            <div slot="modal-footer">
                <b-button v-b-modal.smartop-modal-2><i class="fas fa-chevron-left"></i>&nbsp;&nbsp;Previous</b-button>&nbsp;
                <b-button @click="validateStepThree()">Next&nbsp;&nbsp;<i class="fas fa-chevron-right"></i></b-button>
            </div>
        </b-modal>


        <b-modal ref="smartop-modal-4" id="smartop-modal-4" title="Configure Smartop - DecoShield" no-stacking no-close-on-backdrop>
            <div class="row" v-if="(item.style > -1)">
                <vue-select-image :selectedImages="selectedImages" :dataImages="dataImages" :h="'100px'" :w="'100px'" :useLabel="true" @onselectimage="selectDeco">
                </vue-select-image>
            </div>

            <div slot="modal-footer">
                <b-button v-b-modal.smartop-modal-3><i class="fas fa-chevron-left"></i>&nbsp;&nbsp;Previous</b-button>&nbsp;
                <b-button @click="validateStepFour()">Next&nbsp;&nbsp;<i class="fas fa-chevron-right"></i></b-button>
            </div>
        </b-modal>

        <b-modal ref="smartop-modal-5" id="smartop-modal-5" title="Configure Smartop - Options" no-stacking no-close-on-backdrop>
            <div v-if="(item.style > -1)">
                <div
                    class="mb-3"
                    v-for="(value, key) in item.productList[item.style].options"
                    :key="key">
                  <div v-if="!(item.productList === productdata.jacuzzi400products && value.name === 'SmartShield 800')">
                    <label>{{ value.name }} *</label>
                    <b-form-select v-model="item.options[key]">
                      <option v-for="(value2,key2) in item.productList[item.style].options[key].values" :key="key2" :value="key2">{{ value2.dropdown_label }}</option>
                    </b-form-select>
                  </div>
                </div>

            </div>
            <div slot="modal-footer">
                <b-button v-b-modal.smartop-modal-3><i class="fas fa-chevron-left"></i>&nbsp;&nbsp;Previous</b-button>&nbsp;
                <b-button @click="validateStepFive()">Next&nbsp;&nbsp;<i class="fas fa-chevron-right"></i></b-button>
            </div>
        </b-modal>

        <b-modal ref="smartop-modal-6" id="smartop-modal-6" title="Configure Smartop - Comments" no-stacking no-close-on-backdrop>
            <div>
            <b-form-textarea
              v-model="item.comments"
              placeholder="Enter any special needs/notes regarding this Smartop here"
              rows="6"
              max-rows="8"
            ></b-form-textarea>
            </div>

            <div slot="modal-footer">
                <b-button v-b-modal.smartop-modal-5><i class="fas fa-chevron-left"></i>&nbsp;&nbsp;Previous</b-button>&nbsp;
                <b-button @click="$bvModal.hide('smartop-modal-6')">Finish</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true,
            },
            productdata: {
                type: Object,
                required: true,
                default: function(){
                    return { products:[], jacuzzi400products:[]}
                }
            },
            index: {
                type: Number,
                required: true
            }
        },
        computed: {
            oversizeFee: function() {
                return this.getOversizeFee();
            },
            isComplete: function(){
                this.trigger;
                var complete = false;

                complete = (this.stepIsValid(1) && this.stepIsValid(2) && this.stepIsValid(3) && this.stepIsValid(4) && this.stepIsValid(5)) ;

                // eslint-disable-next-line
                this.item.isComplete = complete;

                return complete;
            },
            totalPrice: function() {
                var tPrice = 0;
                var key = 0;

                if (typeof this.item.productList === 'undefined') {
                    return 0;
                }

                // if style hasn't been selected, leave
                if(!(this.item.style > -1)){
                    return 0;
                }

                //base price of style
                tPrice += parseFloat(this.item.productList[this.item.style].price);


                //oversize fee
                tPrice += this.getOversizeFee();
                tPrice += this.getCompletionDateFee();

                //set base price on this item, must happen after oversize
                // eslint-disable-next-line
                this.item.price = tPrice;
                // eslint-disable-next-line
                this.item.oversize = this.isOversize();

                // Smartop Upright styles have multiple selections at options == 0, the others do not. Set to 0
                // if the style is not Smartop Upright to prevent selecting an option that doesnt exist.
                if ((this.item.style !== 2 && this.item.style !== 0) && this.item.options[0] !== 0) {
                  this.$set(this.item.options, 0, 0);
                }

                //add all options (this includes mounts and smartshield)
                for (key in this.item.options) {
                    //add price
                    tPrice += parseFloat(this.item.productList[this.item.style].options[key].values[this.item.options[key]].price);
                }

                /*
                    Save price back to current item on every calc. Probably a more intelligent
                    way to do this, but it works.
                */

                // eslint-disable-next-line
                this.item.totalPrice = tPrice;

                //return
                return tPrice;
            },
        },
        methods: {
            isNumber(event) {
                if (!/\d/.test(event.key) && (event.key !== ".")
                )
                    return event.preventDefault();
                },
            edit(){
                //load hingelengths
                this.updateHingeLengths();

                //load decos
                this.updateDecos();

                //start editing myself
                this.$refs['smartop-modal-1'].show();

                //flag myself as no longer new, first time
                this.item.isNew = false;
            },
            deleteme(){
                this.$parent.removeItem(this.index)
            },
            addDuplicate(){
              this.$parent.addDuplicate(this.index);
            },
            getCompletionDateFee: function() {
              if (!(this.item.style > -1)) {
                return 0;
              }

              return parseFloat(this.item.productList[this.item.style]
                  .completion_date.find((element) => element.value === this.item.completionOption)
                  .price
              );
            },
            getOversizeFee: function() {
                if(this.isOversize() === true) {
                    return parseFloat(this.item.productList[this.item.style].oversize.price);
                }else{
                    return 0;
                }
            },
            isOversize() {
                var oversize = false;

                // if style hasn't been selected, leave
                if(!(this.item.style > -1)){
                    return false;
                }

                if (parseFloat(this.item.measurementA) >= parseFloat(this.item.productList[this.item.style].oversize.a)) {
                    oversize = true;
                }

                if (parseFloat(this.item.measurementB) >= parseFloat(this.item.productList[this.item.style].oversize.b)) {
                    oversize = true;
                }

                return oversize;
            },
            updateHingeLengths() {
              if (this.item.source == 'bullfrog') {
                return;
              }
                this.productdata.measurements.hingeLength = [];

                if(this.item.measurementA <= 110) {
                    this.productdata.measurements.hingeLength.push (this.item.measurementA);
                }

                if(this.item.measurementB <= 110) {
                    this.productdata.measurements.hingeLength.push (this.item.measurementB);
                }

                // if hingelength is no longer an option, clear it out
                if(!(this.productdata.measurements.hingeLength.includes(this.item.hingeLength))){
                    this.item.hingeLength = '';
                }
            },
            loadDecos() {
                var key;

                if (typeof this.item.productList === 'undefined') {
                    return 0;
                }

                //empty deco images
                this.dataImages.length = 0;

                if( this.item.style > -1){
                    //populate deco images
                    for (key in this.item.productList[this.item.style].decos) {
                        let image = {
                            id: key,
                            src: this.item.productList[this.item.style].decos[key]['image'],
                            alt: this.item.productList[this.item.style].decos[key]['name']
                        }
                        this.dataImages.push( image );
                    }


                }else{
                    //populate deco images with first element
                    for (key in this.item.productList[0].decos) {
                        let image = {
                            id: key,
                            src: this.item.productList[0].decos[key]['image'],
                            alt: this.item.productList[0].decos[key]['name']
                        }
                        this.dataImages.push( image );
                        //preselect black deco if using bullfrog form
                        if (this.item.source == 'bullfrog' && this.item.productList[0].decos[key]['name'] == "Black Deco") {
                          this.selectDeco(image);
                        }
                    }
                }

                this.updateDecos();
            },
            updateDecos() {
                var key;
                this.selectedImages.length = 0;
                this.dataImages.length = 0;

                // Per LC-796: auto select our only current deco.
                // We may add more later and add this step back.
                for (key in this.item.productList[0].decos) {
                  let image = {
                    id: key,
                    src: this.item.productList[0].decos[key]['image'],
                    alt: this.item.productList[0].decos[key]['name']
                  }
                  this.dataImages.push( image );
                  //preselect black deco
                  if (this.item.productList[0].decos[key]['name'] == "Black Deco") {
                    this.selectDeco(image);
                  }
                }
            },
            selectDeco(objectImage) {
                this.item.decoShield = objectImage.id;
                this.selectedImages.length = 0;
                this.selectedImages.push ( objectImage );
            },
            stepIsValid(stepNumber) {
                switch (stepNumber){
                    case 1:
                      return (
                          this.item.spaBrand &&
                          this.item.spaModel &&
                          this.item.spaYear &&
                          this.item.customerName &&
                          this.item.spaReason &&
                          this.item.salespersonFirstName &&
                          this.item.salespersonLastName &&
                          this.item.departmentFrom &&
                          this.item.location &&
                          ( this.item.spaBrand !== 'other' || this.item.spaBrandOther) &&
                          ( this.item.completionOption !== 'date' || this.item.completionDate)
                      );
                    case 2:
                        return (this.item.measurementA && this.item.measurementB && this.item.hingeLength && this.item.cornerRadius && this.item.acrylicHeight);
                    case 3:
                        return (this.item.style > -1);
                    case 4:
                        return (this.item.decoShield > -1);
                    case 5:

                      if (this.item.productList[this.item.style].options.length > this.item.options.length) {
                        return false;
                      }

                      //options, loop through and make sure something was selected
                      return this.item.options.every(function(e){
                          return e > -1;
                      });
                }

                return false;
            },
            validateStepOne(){
                if(this.stepIsValid(1)){
                    this.setProductList();
                    this.$refs['smartop-modal-2'].show()
                    this.$parent.persist();
                }
            },
            validateStepTwo() {
                if(this.stepIsValid(2)){
                    this.$refs['smartop-modal-3'].show()
                    this.$parent.persist();
                }
            },
            validateStepThree() {
                if(this.stepIsValid(3)){
                    this.$refs['smartop-modal-5'].show()
                    this.$parent.persist();
                }

                this.trigger++;
            },
            validateStepFour() {
                if(this.stepIsValid(4)){
                    this.$refs['smartop-modal-5'].show()
                    this.$parent.persist();
                }

                this.trigger++;
            },
            validateStepFive() {
                if(this.stepIsValid(5)){

                  // The smartshield 800 option is always added to Jacuzzi 400 products. This handles the case where the
                  // v-if above hides the smartshield option.
                  if (this.item.style !== undefined) {
                    for (const optionsKey in this.item.productList[this.item.style].options ) {
                      if (this.item.productList[this.item.style].options[optionsKey].values.length === 1) {
                        this.item.options[optionsKey] = 0;
                      }
                    }
                  }

                  this.$refs['smartop-modal-6'].show()
                  this.$parent.persist();
                }
            },
          setProductList() {
            this.item.productList = this.productdata.products;
            if (this.item.spaBrand === "Jacuzzi" && this.item.spaYear >= 2020) {

              const jacuzziModels = ['425', '435', '445', '475', '485', '495'];
              for(let i = 0; i < jacuzziModels.length; i++) {
                if (this.item.spaModel.indexOf(jacuzziModels[i]) > -1) {
                  this.item.productList = this.productdata.jacuzzi400products;
                  break;
                }
              }
            }

            this.loadDecos();
          },
          getCustomCorners(spaModel) {
            //gather the conditional values for measurements and corner radius based on spaModel selection,
            //but do it here rather than limiting what is returned from the api data so the options remain for additional items
            let filteredOptions = []
            if (spaModel === "S150") {
              filteredOptions.cornerRadius = [this.productdata.measurements.cornerRadius[0]];
              filteredOptions.measurementA = [this.productdata.measurements.a[0]];
              this.item.measurementA = filteredOptions.measurementA[0];
              this.item.cornerRadius = filteredOptions.cornerRadius[0];
            }
            if (spaModel === "S200") {
              filteredOptions.cornerRadius = [this.productdata.measurements.cornerRadius[1]];
              filteredOptions.measurementA = [this.productdata.measurements.a[1]];
              this.item.measurementA = filteredOptions.measurementA[0];
              this.item.cornerRadius = filteredOptions.cornerRadius[0];
            }
            return filteredOptions;
          }
        },
        mounted() {
            this.loadDecos();

            if(this.item.isNew){
                this.edit();
            }
        },
        data() {
            return {
                options: [],
                selectedImages: [],
                dataImages: [],
                error: false,
                trigger: 0,
            }
        }
    }
</script>

<style>
.vue-select-image__lbl{
  font-size: 10px !important;
  font-weight: bold !important;
  line-height: 1 !important;
}

.vue-select-image__thumbnail--selected{
  background: #dc3545 !important;
  color: #ffffff !important;
}
</style>
